module.exports = __webpack_public_path__ + "img/1.478c795b.png";